import { CARRIER } from '../constants'

export const isExpressOrExpressEconomy = (carrierKey: string | null | undefined): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  isExpress(carrierKey) || isExpressEconomy(carrierKey)

export const isExpress = (carrierKey: string | null | undefined): boolean => carrierKey === CARRIER.EXPRESS

export const isExpressEconomy = (carrierKey: string | null | undefined): boolean =>
  carrierKey === CARRIER.EXPRESS_ECONOMY

export const isDhlParcel = (carrierKey: string | null | undefined): boolean => carrierKey === CARRIER.PARCEL
